var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"selectBtn",class:_vm.active ? 'active' : ''},[(_vm.icon != null)?_c('img',{staticClass:"degree-img",attrs:{"src":_vm.icon}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.$t(_vm.text)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }